import React from "react";
import { useTranslation } from "react-i18next";
import "./CarruselPostulate.css";

export default function CarrusellPostulate() {
  const { t } = useTranslation();

  return (
    <div className="carrusel-postulate-container">
      <img
        src="/card2.webp"
        alt={t("carrusel_postulate.alt_image")}
        className="carrusel-postulate-img"
      />
      <div className="carrusel-postulate-overlay">
        <h2 className="carrusel-postulate-title">
          {t("carrusel_postulate.title")}
          <br />
        </h2>
      </div>
    </div>
  );
}

